import { useQuery } from '@tanstack/react-query';
import { getAuthConfig } from '@/api/auth';

export function useAuthConfig() {
  return useQuery({
    queryKey: ['auth', 'config'],
    queryFn: getAuthConfig,
    staleTime: 5 * 60 * 1000,
  });
}
